import { BalanceSheetInputBalance } from '../../reports/views/NL/balanceSheetReport/types/inputTypes'
import { BalanceSheetTableBalance } from '../../reports/views/NL/balanceSheetReport/types/tableTypes'
import { ProfitAndLossInputBalance } from '../../reports/views/NL/profitAndLossReport/types/inputTypes'
import { ProfitAndLossTableBalance } from '../../reports/views/NL/profitAndLossReport/types/tableTypes'
import { TrialBalanceInputBalance } from '../../reports/views/NL/trialBalanceReport/types/inputTypes'
import { TrialBalanceTableBalance } from '../../reports/views/NL/trialBalanceReport/types/tableTypes'
import { PeriodValue } from '../types/inputTypes'

export const mapBalanceSheetBalances = (
  columnValues: BalanceSheetInputBalance,
  periods?: PeriodValue[],
): BalanceSheetTableBalance[] => {
  if (!periods) {
    return []
  }

  return periods.map((period) => ({
    type: 'period',
    period: period.key,
    balance: columnValues?.[period.key]?.value || 0,
  }))
}

export const mapProfitAndLossBalances = (
  columnValues: ProfitAndLossInputBalance,
  periods?: PeriodValue[],
): ProfitAndLossTableBalance[] => {
  if (!periods) {
    return []
  }

  return periods.map((period) => ({
    type: 'period',
    period: period.key,
    balance: columnValues?.[period.key] || {
      total: 0,
      percentageChange: 0,
      percentageOfType: 0,
    },
  }))
}

export const mapTrialBalanceBalances = (columnValues: TrialBalanceInputBalance): TrialBalanceTableBalance[] => {
  const { closingBalance, credit, debit, openingBalance } = columnValues

  return [
    { type: 'opening_balance', balance: openingBalance.value },
    { type: 'debit', balance: debit.value },
    { type: 'credit', balance: credit.value },
    { type: 'closing_balance', balance: closingBalance.value },
  ]
}
